var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4822 0.18229C18.4851 0.120971 18.4882 0.0602012 18.4916 0C18.4887 0.0609544 18.4856 0.121717 18.4822 0.18229C18.1959 6.43217 21.3037 18.4008 36.0938 17.6859C30.0526 18.1067 18.081 22.3722 18.4902 36.0652C18.3025 30.093 14.4124 18.2919 0.374006 18.2264C0.246823 18.2283 0.122103 18.2286 0 18.2273C0.125462 18.2261 0.250129 18.2258 0.374006 18.2264C6.33339 18.1348 17.6991 14.4512 18.4822 0.18229Z",
    fill: "#006BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/Shape3.ba0fdaacbc2cc51ccbd846f39c3fc6e5.svg";
export { ForwardRef as ReactComponent };